import { createSelector } from '@reduxjs/toolkit';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';

export const selectCurrentPage = (state: ReduxApplicationState) =>
  state.products.lastPageLoaded || 0;

export const selectPreviousPage = (state: ReduxApplicationState) =>
  state.products.lastPageLoaded ? state.products.lastPageLoaded - 1 : 0;

export const selectTotalProducts = (state: ReduxApplicationState) => state.products.totalProducts;

export const selectProductFromCode = createSelector(
  [
    ({ products }: ReduxApplicationState) => products.pages,
    (_, productCode: number) => productCode,
  ],
  (products, productCode) =>
    Object.values(products)
      .flat()
      .find(({ code }) => code === productCode),
);

export const selectProviderAttributionToken = ({ products }: ReduxApplicationState) =>
  products.providerAttributionToken;

export const selectProviderMetadata = ({ products }: ReduxApplicationState) =>
  products.providerMetadata;

/**
 * The code of the first product on the lowest-numbered page the store holds, or
 * `undefined` when it holds none.
 *
 * Exists for the partner page's recommendations request, which needs a real
 * product to recommend against. Taken from the first page held rather than the
 * page currently in view so that paging or loading more does not change it,
 * which matters because the seed is a dependency of that fetch.
 */
export const selectFirstLoadedProductCode = ({ products }: ReduxApplicationState) =>
  Object.values(products.pages)[0]?.[0]?.code;
